import { isSameDay } from 'date-fns';

/**
 * Hourly bookings whose end falls on a later calendar day store an exclusive
 * end (e.g. next-day 00:00). Those ends read a day too far, so the planner
 * tooltip and the booking form show them one second earlier — display only,
 * every persisted or computed value keeps the stored end.
 */
export function isCrossDayHourly(
  durationType: string | undefined,
  start: Date | null | undefined,
  end: Date | null | undefined,
): boolean {
  if (durationType !== 'hourly' || !start || !end) return false;
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;
  return !isSameDay(start, end);
}

/** The stored end shifted back one second, for display only. */
export function oneSecondEarlier(end: Date): Date {
  return new Date(end.getTime() - 1000);
}

/**
 * An "HH:mm" time one second earlier, i.e. the previous minute (00:00 → 23:59),
 * since a time input only renders hours and minutes.
 */
export function subtractOneSecondFromTime(time: string): string {
  const [h, m] = time.split(':').map(Number);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return time;
  const minutesInDay = 24 * 60;
  const total = (h * 60 + m - 1 + minutesInDay) % minutesInDay;
  const hh = String(Math.floor(total / 60)).padStart(2, '0');
  const mm = String(total % 60).padStart(2, '0');
  return `${hh}:${mm}`;
}
